import React from "react";
import { useEffect, useState, createContext, useRef } from 'react';
import request from '../../../Helpers/API';
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import SaveIcon from '@mui/icons-material/Save';
import { TextField, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { LoaderScreen } from "../../components/LoaderScreen";

export const ReversasPendientesAplicarSection = ({ data, botones, actualiza }) => {
    const [reversas, setReversas] = useState([]);
    const [origenes, setOrigenes] = useState([]);
    const [refacturaciones, setRefacturaciones] = useState([]);
    const [selectedReversa, setSelectedReversa] = useState();
    const [selectedOrigen, setSelectedOrigen] = useState();
    const [selectedRefacturacion, setSelectedRefacturacion] = useState();
    const [search, setSearch] = useState("");
    const [searchSerie, setSearchSerie] = useState("");
    const [searchFolio, setSearchFolio] = useState("");
    const [searchRefacturacion, setSearchRefacturacion] = useState("");
    const [searchRefacturacionSerie, setSearchRefacturacionSerie] = useState("");
    const [searchRefacturacionFolio, setSearchRefacturacionFolio] = useState("");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    useEffect(() => {
        setOrigenes([]);
        setRefacturaciones([]);
        setSelectedOrigen();
        setSelectedRefacturacion();
        setSelectedReversa();
        setSearch("");
        setSearchSerie("");
        setSearchFolio("");
        setSearchRefacturacion("");
        setSearchRefacturacionSerie("");
        setSearchRefacturacionFolio("");
        setReversas(data);
    }, [data]);

    const onSearchDocumento = (documento, serie, folio) => {
        if (documento === '')
            documento = '-1'
        if (serie === '')
            serie = '-1'
        if (folio === '')
            folio = '-1'
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ListadoInvoiceMoviemientos/BuscarDocumentoInvoice?documento=${documento}&serie=${serie}&folio=${folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setOrigenes(result);
                    resolve(result);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("DASHBOARD FISCAL", JSON.stringify(error), "error");
                    reject(error);
                });
        });
    };

    const onSearchDocumentoRefacturacion = (documento, serie, folio) => {
        if (documento === '')
            documento = '-1'
        if (serie === '')
            serie = '-1'
        if (folio === '')
            folio = '-1'
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ListadoInvoiceMoviemientos/BuscarDocumentoInvoice?documento=${documento}&serie=${serie}&folio=${folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setRefacturaciones(result);
                    resolve(result);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("DASHBOARD FISCAL", JSON.stringify(error), "error");
                    reject(error);
                });
        });
    };

    const handleClickReversa = (documento) => {

        const isSame = selectedReversa === documento;

        setSelectedReversa(isSame ? "" : documento);

        if (isSame) {
            setSearch("");
            setSearchSerie("");
            setSearchFolio("");
            setSearchRefacturacion("");
            setSearchRefacturacionSerie("");
            setSearchRefacturacionFolio("");
            setOrigenes([]);
            setRefacturaciones([]);
            setSelectedOrigen();
            setSelectedRefacturacion();
            return;
        }

        const reversa = reversas.find(r => r.document_no === documento);

        setSearch("");
        setSearchSerie("");
        setSearchFolio("");
        setSearchRefacturacion("");
        setSearchRefacturacionSerie("");
        setSearchRefacturacionFolio("");
        setOrigenes([]);
        setRefacturaciones([]);
        setSelectedOrigen();
        setSelectedRefacturacion();

        if (reversa?.orig_invoice_no) {
            onSearchDocumento(reversa.orig_invoice_no, '', '').then(() => {
                setSearch(reversa.orig_invoice_no);
                setSearchSerie('');
                setSearchFolio('');
                setSelectedOrigen(reversa.orig_invoice_no);
            });
        }

        if (reversa?.document_refacturacion) {
            onSearchDocumentoRefacturacion(reversa.document_refacturacion, '', '').then(() => {
                setSearchRefacturacion(reversa.document_refacturacion);
                setSearchRefacturacionSerie('');
                setSearchRefacturacionFolio('');
                setSelectedRefacturacion(reversa.document_refacturacion);
            });
        }
    };

    // console.log(reversas)
    const handleSelectOrigen = (documento) => {
        setSelectedOrigen(prev =>
            prev === documento ? "" : documento
        );
    };

    const handleSelectRefacturacion = (documento) => {
        setSelectedRefacturacion(prev =>
            prev === documento ? "" : documento
        );
    };

    const onAplicar = () => {
        setLoader({ ...loader, mostrar: true });

        const reversa = reversas.find(r => r.document_no === selectedReversa);
        const origen = origenes.find(o => o.documento === selectedOrigen);
        const refacturacion = refacturaciones.find(f => f.documento === selectedRefacturacion);

        const importeReversa = reversa?.total || 0;
        const importeOrigen = origen?.importe || 0;
        const importeRefacturacion = refacturacion?.importe || 0;

        if (reversa && origen) {
            if (Math.trunc(Math.abs(importeReversa)) !== Math.trunc(Math.abs(importeOrigen))) {
                Swal.fire("Advertencia", "Los importes de los documentos seleccionados no coinciden", "warning");
                setLoader({ ...loader, mostrar: false });
                return;
            }
        }


        if (selectedRefacturacion) {
            if (Math.trunc(Math.abs(importeRefacturacion)) !== Math.trunc(Math.abs(importeReversa))) {
                Swal.fire("Advertencia", "Los importes de los documentos de refacturacion y reversa no coinciden", "warning");
                setLoader({ ...loader, mostrar: false });
                return;
            }
        }

        if (!selectedOrigen) {
            Swal.fire({
                title: "¿Estás seguro?",
                text: "No tienes seleccionado ningun origen para la reversa seleccionada ¿Deseas continuar?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, continuar",
                cancelButtonText: "Cancelar"
            }).then((result) => {

                if (!result.isConfirmed) return;

                const post = {
                    document_cancelacion: selectedReversa,
                    document_orig: 0,
                    document_refacturacion: 0
                };
                request
                    .post("ListadoInvoiceMoviemientos/AplicarReversa", post)
                    .then(() => {
                        setLoader({ ...loader, mostrar: false });

                        Swal.fire(
                            "Éxito",
                            "Reversa aplicada con éxito",
                            "success"
                        );

                        actualiza();
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire(
                            "Error",
                            JSON.stringify(error),
                            "error"
                        );
                    });
            });

            return;
        }


        if (!selectedRefacturacion) {
            Swal.fire({
                title: "¿Estás seguro?",
                text: "La reversa no está asociada a una refacturación. ¿Deseas continuar?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, continuar",
                cancelButtonText: "Cancelar"
            }).then((result) => {

                if (!result.isConfirmed) return;

                const post = {
                    document_cancelacion: selectedReversa,
                    document_orig: selectedOrigen,
                    document_refacturacion: 0
                };
                request
                    .post("ListadoInvoiceMoviemientos/AplicarReversa", post)
                    .then(() => {
                        setLoader({ ...loader, mostrar: false });

                        Swal.fire(
                            "Éxito",
                            "Reversa aplicada con éxito",
                            "success"
                        );

                        actualiza();
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire(
                            "Error",
                            JSON.stringify(error),
                            "error"
                        );
                    });
            });

            return;
        }

        const post = {
            document_cancelacion: selectedReversa,
            document_orig: selectedOrigen,
            document_refacturacion: selectedRefacturacion
        };
        request
            .post("ListadoInvoiceMoviemientos/AplicarReversa", post)
            .then(() => {
                setLoader({ ...loader, mostrar: false });

                Swal.fire(
                    "Éxito",
                    "Reversa aplicada con éxito",
                    "success"
                );

                actualiza();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "Error",
                    JSON.stringify(error),
                    "error"
                );
            });
    };



    return (
        <div className="listado-fiscal-invoicemovimientos-container">
            <LoaderScreen loader={loader} />
            <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                <table>
                    <thead>
                        <tr>
                            <th colSpan={8}>
                                Reversas
                            </th>
                        </tr>
                        <tr>
                            <th>

                            </th>
                            <th>
                                Documento
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            {/* <th>
                                <div>Gasto</div>
                            </th> */}
                            <th>
                                <div>Serie Fiscal</div>
                            </th>
                            {/* <th>
                                <div>Folio Fiscal</div>
                            </th> */}
                            <th>
                                <div>Batch</div>
                            </th>
                            <th>
                                <div>Descripcion</div>
                            </th>
                            {/* <th>
                                <div>Origen</div>
                            </th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {reversas.map((rev) => (
                            <tr
                                onClick={() => handleClickReversa(rev.document_no)} className={selectedReversa === rev.document_no ? "selected-row" : ""}
                            >
                                <td>{rev.orig_invoice_no != '' ? <span style={{ color: 'green' }}>✔</span> : <span style={{ color: 'orange' }}>⚠</span>}</td>
                                <td className="ta-center">{rev.document_no}</td>
                                <td className="ta-center">{new Date(rev.invo_date).toLocaleDateString("es-MX", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                })}</td>
                                <td className="ta-right">{FormatMoney(rev.total, 0)}</td>
                                {/* <td className="ta-right">{FormatMoney(rev.gst)}</td> */}
                                <td className="ta-center">{rev.series_code} - {rev.fiscal_document_no}</td>
                                {/* <td className="ta-center">{rev.fiscal_document_no}</td> */}
                                <td className="ta-center">{rev.batch}</td>
                                <td className="ta-left">{rev.descripcion}</td>
                                {/* <td className="ta-left">{rev.orig_invoice_no}</td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                <div className="listado-fiscal-invoicemovimientos-container-buscador">
                    <TextField
                        size="small"
                        fullWidth
                        sx={{ mt: 0.2 }}
                        variant="outlined"
                        placeholder="Buscar documento..."
                        value={search}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                                setSearch(value);
                            }
                        }}
                    />

                    <TextField
                        size="small"
                        fullWidth
                        sx={{ mt: 0.2 }}
                        variant="outlined"
                        placeholder="Buscar serie fiscal..."
                        value={searchSerie}
                        onChange={(e) => {
                            setSearchSerie(e.target.value);
                        }}
                    />

                    <TextField
                        size="small"
                        fullWidth
                        sx={{ mt: 0.2 }}
                        variant="outlined"
                        placeholder="Buscar folio fiscal..."
                        value={searchFolio}
                        onChange={(e) => {
                            const value = e.target.value;

                            // solo números
                            if (/^\d*$/.test(value)) {
                                setSearchFolio(value);
                            }
                        }}
                    />

                    <Button
                        variant="contained"
                        onClick={() => onSearchDocumento(search, searchSerie, searchFolio)}
                    >
                        <SearchIcon />
                    </Button>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th colSpan={6}>
                                Origen
                            </th>
                        </tr>
                        <tr>
                            {/* <th>
                            </th> */}
                            <th>
                                Documento
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            <th>
                                <div>Serie Fiscal</div>
                            </th>
                            <th>
                                <div>Folio Fiscal</div>
                            </th>
                            <th>
                                <div>Batch</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {origenes.map((og) => {
                            return (
                                <tr onClick={() => handleSelectOrigen(og.documento)} className={selectedOrigen === og.documento ? "selected-row" : ""}>
                                    {/* <td className="ta-center">
                                        <input
                                            type="checkbox"
                                            checked={false}
                                            // disabled={mov.bloqueado || !botones?.aplicar ? true : false}
                                            onChange={() => handleSelectOrigen(og.documento)}
                                        />
                                    </td> */}
                                    <td className="ta-center">{og.documento}</td>
                                    <td className="ta-center">{new Date(og.fecha).toLocaleDateString("es-MX", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric"
                                    })}</td>
                                    <td className="ta-right">{FormatMoney(og.importe)}</td>
                                    <td className="ta-center">{og.serie_fiscal}</td>
                                    <td className="ta-center">{og.folio_fiscal}</td>
                                    <td className="ta-center">{og.batch}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <div className="listado-fiscal-invoicemovimientos-container-buscador" style={{ marginTop: "10px" }}>
                    <TextField
                        size="small"
                        fullWidth
                        sx={{ mt: 0.2 }}
                        variant="outlined"
                        placeholder="Buscar documento..."
                        value={searchRefacturacion}
                        onChange={(e) => {
                            const value = e.target.value;

                            // solo números
                            if (/^\d*$/.test(value)) {
                                setSearchRefacturacion(value);
                            }
                        }}
                    />

                    <TextField
                        size="small"
                        fullWidth
                        sx={{ mt: 0.2 }}
                        variant="outlined"
                        placeholder="Buscar serie fiscal..."
                        value={searchRefacturacionSerie}
                        onChange={(e) => {
                            setSearchRefacturacionSerie(e.target.value);
                        }}
                    />

                    <TextField
                        size="small"
                        fullWidth
                        sx={{ mt: 0.2 }}
                        variant="outlined"
                        placeholder="Buscar folio fiscal..."
                        value={searchRefacturacionFolio}
                        onChange={(e) => {
                            const value = e.target.value;

                            // solo números
                            if (/^\d*$/.test(value)) {
                                setSearchRefacturacionFolio(value);
                            }
                        }}
                    />

                    <Button
                        variant="contained"
                        onClick={() => onSearchDocumentoRefacturacion(searchRefacturacion, searchRefacturacionSerie, searchRefacturacionFolio)}
                    >
                        <SearchIcon />
                    </Button>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th colSpan={6}>
                                Refacturacion
                            </th>
                        </tr>
                        <tr>
                            {/* <th>
                            </th> */}
                            <th>
                                Documento
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            <th>
                                <div>Serie Fiscal</div>
                            </th>
                            <th>
                                <div>Folio Fiscal</div>
                            </th>
                            <th>
                                <div>Batch</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {refacturaciones.map((re) => {
                            return (
                                <tr onClick={() => handleSelectRefacturacion(re.documento)} className={selectedRefacturacion === re.documento ? "selected-row" : ""}>
                                    <td className="ta-center">{re.documento}</td>
                                    <td className="ta-center">{new Date(re.fecha).toLocaleDateString("es-MX", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric"
                                    })}</td>
                                    <td className="ta-right">{FormatMoney(re.importe)}</td>
                                    <td className="ta-center">{re.serie_fiscal}</td>
                                    <td className="ta-center">{re.folio_fiscal}</td>
                                    <td className="ta-center">{re.batch}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {botones?.aplicar && (
                    <div className="buttons">
                        <button
                            className="listado-fiscal-invoicemovimientos-aplicar"
                            onClick={() => onAplicar()}
                        >
                            <SaveIcon /> Aplicar
                        </button>
                    </div>)}
            </div>
        </div>
    );
};
